// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__QCink","range":"MonthRangeSwitch_range__1utY_","disabled":"MonthRangeSwitch_disabled__10dwK"};